import { ref, readonly } from 'vue'

const INTERVAL = 10 * 60 * 1000
const available = ref(false)
export const updateAvailable = readonly(available)
export const canShowUpdate = (value, currentVersion) => value?.ready === true && typeof value.version === 'string' && value.version.length > 0 && value.version !== currentVersion
export const reloadForUpdate = () => {
  if (!available.value) return false
  window.location.reload()
  return true
}
export const startAppUpdate = (currentVersion) => {
  if (!currentVersion) return
  let checking = false
  const check = async () => {
    if (checking || document.hidden) return
    checking = true
    try {
      const response = await fetch(`${import.meta.env.BASE_URL}version.json?t=${Date.now()}`, {
        cache: 'no-store', signal: AbortSignal.timeout(10000)
      })
      if (!response.ok) return
      const value = await response.json()
      available.value = canShowUpdate(value, currentVersion)
    } catch {
      // 网络异常时保留已有提示，不刷新页面。
    } finally { checking = false }
  }
  void check()
  setInterval(() => { void check() }, INTERVAL)
  document.addEventListener('visibilitychange', () => { if (!document.hidden) void check() })
}
